<template>
  <aside class="sidenav gept_main_bg">
    <ul class="sidenav__list text-white list-none p-0 text-xl font-semibold">
      <li class="sidenav__list_item xl:hidden" :class="{ 'active': $route.name === 'Index' }">
        <router-link @click.native="$emit('closeMenu')" :to="{ name: 'Index' }" class="m-0 flex items-center p-3 px-5 cursor-pointer">
          <img class="inline-block h-auto object-contain mr-2 hover_off" src="@/assets/image/gept/list_logo2.png" alt="">
          <img class="h-auto object-contain mr-2 hover_on" src="@/assets/image/gept/list_logo.png" alt="">
          AI學習首頁
        </router-link>
      </li>
      <li class="sidenav__list_item" :class="{ 'active': $route.name === 'GEPT_Overview' }">
        <router-link @click.native="$emit('closeMenu')" :to="{ name: 'GEPT_Overview' }" class="m-0 flex items-center p-3 px-5 cursor-pointer">
          <img class="inline-block h-auto object-contain mr-2 hover_off" src="@/assets/image/gept/list_logo2.png" alt="">
          <img class="h-auto object-contain mr-2 hover_on" src="@/assets/image/gept/list_logo.png" alt="">
          練習總覽
        </router-link>
      </li>
      <li class="p-3 px-5">
        <a class="bg-red-main-ai text-white p-2 px-3 xl:hidden text-sm cursor-pointer block" @click.prevent="logout2()">LOGOUT</a>
      </li>
    </ul>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'
  export default {
    name: 'Sidebar',

    data () {
      return {
      }
    },
    props: {
    },
    computed: {
      ...mapGetters([
        'authorized',
        'remainPoints',
        'ai_sid',
        'ai_uuid',
        'lang',
        'level'
      ])
    },
    watch: {
    },
    mounted () {
    },
    methods: {
      logout2 () {
        this.$store.dispatch('logout')
        this.$router.replace({ name: 'login' })
      }
    }
  }
</script>

<style lang="scss" scoped>
.sidenav {
  width: 100%;
  max-width: 200px;
  .sidenav__list {
    .sidenav__list_item {
      color: #4496C2;
      .hover_on {
        display: none;
      }
      &:hover {
        background: #91D3F6;
        color: #073E5C;
        .hover_on {
          display: block;
        }
        .hover_off {
          display: none !important;
        }
      }
    }
    .active {
      background: #91D3F6;
      color: #073E5C;
      .hover_on {
        display: block;
      }
      .hover_off {
        display: none !important;
      }
    }
  }
}
</style>
